import { FIELDTYPES } from "../common/constants";
import { ClickStreamEventActions } from "../native/constants";
import { analyticsProcessor, formProcessor } from "./onLoad";

class ValidationProcessor {

    #_errorMessage = {
        EMPTY: "",
        REQUIRED: "field is required",
        INVALID: "Invalid field"
    };

    #_errorConstants = {
        ERROR: "error",
        NONE: "none",
        WARNING: "warning",
        MODAL: "modal"
    };

    #_errorCheck = {
        REGEX: "regex",
        CHECKSUM: "checksum",
        DEFAULT: "default",
        CHECKSUM_REGEX: "checksum_regex",
        REQUIRED: "REQUIRED"
    };

    regExValidation(validationObject) {
        const errorInfo = this.requiredValidation(validationObject);
        if (errorInfo.state === this.#_errorConstants.NONE) {
            if (validationObject?.fieldData?.validation?.validationString) {
                let value = validationObject?.fieldValue;
                if(validationObject?.fieldData?.fieldType === FIELDTYPES.LENGTHTEXT) {
                    value = value?.replaceAll("-", "");
                    value = value?.replaceAll(" ", "");
                }
                const flag = new RegExp(validationObject?.fieldData?.validation?.validationString).test(value);
                if (flag) return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true };
                else {
                    this.validationAnalytics(validationObject, {
                        error : validationObject?.fieldData?.validation?.validationMessage || this.#_errorMessage.INVALID
                    })
                    return { text: validationObject?.fieldData?.validation?.validationMessage || this.#_errorMessage.INVALID, state: this.#_errorConstants.ERROR, type: false };
                }
            }
            return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true };
        }
        return errorInfo;
    }

    requiredValidation(validationObject) {
        if (validationObject?.fieldData?.attributes?.required) {
            if (validationObject?.fieldValue) return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true };
            else {
                const label = validationObject?.fieldData?.attributes?.analytics?.subSection || '';
                this.validationAnalytics(validationObject, {
                    error : validationObject?.fieldData?.attributes?.errorLabel || `${label} ${this.#_errorMessage.REQUIRED}`.trim()
                })
                return { text: validationObject?.fieldData?.attributes?.errorLabel || `${label} ${this.#_errorMessage.REQUIRED}`.trim(), state: this.#_errorConstants.ERROR, type: false };
            }
            }
        return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true };
    }

    checkSumValidation(validationObject) {
        const errorInfo = this.regExValidation(validationObject);
        if (errorInfo.state === this.#_errorConstants.NONE) {
            let fieldValue = validationObject?.fieldValue;
            fieldValue = fieldValue.replaceAll("-", "");
            fieldValue = fieldValue.replaceAll(" ", "");

            const D_TABLE = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
                [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
                [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
                [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
                [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
                [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
                [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
                [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
                [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
            ];

            const P_TABLE = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
                [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
                [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
                [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
                [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
                [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
                [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
            ];

            const INV_TABLE = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

            if (fieldValue.length != 12) {
                if(validationObject?.fieldData?.attributes?.VIDflag && fieldValue.length === 16) {
                    return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true }; 
                }
                else {
                    this.validationAnalytics(validationObject, {
                        error : validationObject?.fieldData?.validation?.validationMessage
                    });
                    return { text: validationObject?.fieldData?.validation?.validationMessage, state: this.#_errorConstants.ERROR, type: false }
                }
            }
            if (fieldValue.match(/[^$,.\d]/)) {
                this.validationAnalytics(validationObject, {
                    error : validationObject?.fieldData?.validation?.validationMessage
                });
                return { text: validationObject?.fieldData?.validation?.validationMessage, state: this.#_errorConstants.ERROR, type: false }
            }

            const aadhaarArray = fieldValue.split('');
            const toCheckChecksum = aadhaarArray.pop();

            let c = 0;
            const invertedArray = aadhaarArray.reverse();
            for (var i = 0; i < invertedArray.length; i++) {
                c = D_TABLE[c][P_TABLE[((i + 1) % 8)][invertedArray[i]]];
            }

            if (INV_TABLE[c] == toCheckChecksum) {
                return { text: this.#_errorMessage.EMPTY, state: this.#_errorConstants.NONE, type: true };
            } else {
                this.validationAnalytics(validationObject, {
                    error : validationObject?.fieldData?.validation?.validationMessage
                });
                return { text: validationObject?.fieldData?.validation?.validationMessage, state: this.#_errorConstants.ERROR, type: false };
            }
        }
        return errorInfo;
    }

    validateAllFields(fieldsToCheck) {
        for (let key of fieldsToCheck) {
            const fieldData = formProcessor.getField(key);
            const fieldValue = formProcessor.getFieldValue(key);
            if (fieldData) {
                const errorInfo = this.validateField({
                    fieldId: key,
                    fieldValue: fieldValue,
                    fieldData: fieldData,
                    type: fieldData?.validation?.validationType || "default"
                });
                if (errorInfo) {
                    fieldData.errorListener &&
                        fieldData.errorListener({
                            fieldId: key,
                            value: fieldValue,
                            errorInfo: errorInfo,
                        });
                }
            }
        }
    }

    validateField(validationObject) {
        switch (validationObject.type) {
            case this.#_errorCheck.REGEX: return this.regExValidation(validationObject);
            case this.#_errorCheck.CHECKSUM_REGEX:
            case this.#_errorCheck.CHECKSUM: return this.checkSumValidation(validationObject);
            case this.#_errorCheck.DEFAULT: return this.regExValidation(validationObject);
            case this.#_errorCheck.REQUIRED: return this.requiredValidation(validationObject);
            default: return this.requiredValidation(validationObject);
        }
    }

    validationAnalytics(validationObject, errorObject) {
        analyticsProcessor.createAndSendAnalytics({
            analyticsId: `${validationObject?.fieldData?.id}analytics`,
            sectionId: validationObject?.fieldData?.sectionId,
            metric: {
                section : validationObject?.fieldData?.attributes?.analytics?.section || "",
                subSection: validationObject?.fieldData?.attributes?.analytics?.subSection,
                eventLabel: validationObject?.fieldData?.attributes?.analytics?.eventLabel || validationObject?.fieldData?.label,
				eventValue: validationObject?.fieldValue,
                action: ClickStreamEventActions.error,
                eVar32: errorObject.error
            }
	    })
    }
}

export { ValidationProcessor };